import { createSlice } from "@reduxjs/toolkit";
import {deleteFiles, getFiles, uploadFiles} from '../thunks/filesUploadThunk';
import { toast } from "react-toastify";

const initialState = {
    isGetFilesLoading: false,
    isDeleting: false,
    isDownloading: false,
    isUploading: false,
    isUploadOpen: false,
    error:null,
    files: [],
    filesData: [],
    selectedFiles: [],
    isSelectedAll: false,
    selectedFile: [],
    currentPage: 1,
    pageSize: 10,
    totalPages: 0,
}

const filesUpload = createSlice({
    name: 'filesUpload',
    initialState: initialState,
    reducers: {
        handleSelected(state, action) {
            let updatedSelected = [];
            const selectedId = action.payload.selectedId;
            const isSelected = state.selectedFiles.includes(selectedId);
            if (action.payload.type === "row_selected") {
                if (isSelected) {
                    updatedSelected = state.selectedFiles.filter(id => id !== selectedId);
                }
                else {
                    updatedSelected = [...state.selectedFiles, selectedId];
                }
            }
            else if (action.payload.type === "selected_all") {
                updatedSelected = state.isSelectedAll ? [] : state.files.map(item => item.id);
            }
            else if(action.payload.type === "unselect") updatedSelected = [];
            const isSelectedAll = state.files.length === updatedSelected.length;
            return {
                ...state,
                isSelectedAll,
                selectedFiles: updatedSelected
            }

        },
        setCurrentPage: (state, action) => {
            state.currentPage = action.payload;
        },
        handleSearch: (state, action) => {
            const { searchTerm } = action.payload;
            const filteredFiles = state.filesData.filter(file => {
                const filesData = Object.values(file)
                    .map(value => (typeof value === 'string' ? value.trim().toLowerCase() : value))
                    .join(' ');
                const trimmedSearchTerm = searchTerm?.trim()?.toLowerCase();
                return filesData.includes(trimmedSearchTerm);
            });
            return {
                ...state,
                files:filteredFiles,
                totalPages: Math.ceil(filteredFiles.length / (state.pageSize ?? 1)),
                currentPage: 1,
            };
        },
        setSelectedAllFalse(state, action) {
            return {
                ...state,
                isSelectedAll: false
            }
        },
        handleUploadModal(state,action){
            return {
                ...state,
                isUploadOpen: !state.isUploadOpen,
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFiles.fulfilled, (state, action) => {
                state.files = action.payload?.result;
                state.filesData = action.payload?.result;
                state.totalPages = Math.ceil((action.payload?.result.length) / state.pageSize)
                state.error = null;
                state.isGetFilesLoading = false;
            })
            .addCase(getFiles.pending, (state, action) => {
                state.isGetFilesLoading = true;
                state.error = null;
            })
            .addCase(getFiles.rejected, (state, action) => {
                state.isGetFilesLoading = false;
                state.error = action.payload;
            })
            .addCase(uploadFiles.fulfilled, (state, action) => {
                state.error = null;
                state.isUploading = false;
                if(action.payload.status_code=== 200){
                    toast.success("File uploaded successfully.")
                }
            })
            .addCase(uploadFiles.pending, (state, action) => {
                state.isUploading = true;
                state.error = null;
            })
            .addCase(uploadFiles.rejected, (state, action) => {
                state.isUploading = false;
                state.error = action.payload;
            })
            .addCase(deleteFiles.fulfilled, (state, action) => {
                state.error = null;
                state.isUploading = false;
                if(action.payload.status_code === 200){
                    toast.success(`${state.selectedFiles.length > 1 ? 'Files' : 'File'} deleted successfully.`)
                }
            })
            .addCase(deleteFiles.pending, (state, action) => {
                state.uploadFiles = true;
                state.error = null;
            })
            .addCase(deleteFiles.rejected, (state, action) => {
                state.uploadFiles = false;
                state.error = action.payload;
            })
    }
})
export const fileUploadActions = filesUpload.actions;
export default filesUpload.reducer;